export const company_displayed_columns_locale = {
  accountNumber: "Account nr.",
  companyName: "Company",
  address: "Address",
  vatNumber: "VAT nr.",
  messageType: "Message type",
  isBlocked: "Is blocked",
};
